import { Link } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import Timeline from "../../components/widgets/Timeline";
import { BUYER_STEPS } from "../../js/utils/formatters";

export default function ChecklistOverview() {
  const items = BUYER_STEPS.map((step) => ({
    id: step.path,
    label: step.label,
    detail: step.path,
    complete: false,
  }));

  return (
    <AppLayout>
      <h1>Buyer Checklist Map</h1>
      <div className="title-rule" />
      <p className="page-lead">
        This is a map of the buyer path — not a second checklist and not the Main Dashboard. Work
        happens on each step, starting from Welcome.
      </p>
      <div className="card">
        <Timeline items={items} />
        <Link to="/start" className="primary-btn">
          Begin as a buyer
        </Link>
      </div>
    </AppLayout>
  );
}
